import { Raca } from 'src/tipos'

export const SELECT_RACA = Object.keys(Raca).map(item => ({
  id: item,
  texto: Raca[item as keyof typeof Raca]
}))
